<template>
	<div>
		<v-menu
			v-model="menuOpen"
			bottom
			offset-y
			left
			min-width="500"
			max-width="500"
			content-class="container-notification-menu-header white"
			:close-on-content-click="false"
			:close-on-click="false"
			v-if="$checkPermissions(['edit_company']) && isMyCompany"
		>
			<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							v-bind="{ ...menuAttrs, ...tooltipAttrs }"
							v-on="{ ...menuOn, ...tooltipOn }"
						>
							<v-icon small dark>mdi-cog</v-icon>
						</v-btn>
					</template>
					<span>Configuraciones Empresa</span>
				</v-tooltip>
			</template>
			<div class="white" style="position: relative;">
				<div class="d-flex justify-space-between grey darken-3 px-4 py-1">
					<p class="mb-0 caption white--text">Configuraciones Empresa</p>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="white"
								v-bind="attrs"
								v-on="on"
								@click="() => menuOpen = false"
							>
								<v-icon dark>mdi-close</v-icon>
							</v-btn>
						</template>
						<span>Cerrar</span>
					</v-tooltip>
				</div>
				<v-btn-toggle
					v-model="tab"
					dense
					tile
					mandatory
					class="d-flex flex-row custom-toggle-btns"
					v-if="company?.config?.supervision_allowed"
				>
					<v-btn :value="0" class="flex-grow-1"
						:color="tab == 0 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 0 ? 'white--text':''">Impuestos</p>
						</div>
					</v-btn>
					<v-btn :value="1" class="flex-grow-1"
						:color="tab == 1 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 1 ? 'white--text':''">Tipos de Estructura</p>
						</div>
					</v-btn>
					<v-btn :value="2" class="flex-grow-1"
						:color="tab == 2 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="tab == 2 ? 'white--text':''">Porcentajes de Patrocinio</p>
						</div>
					</v-btn>
				</v-btn-toggle>
				<v-tabs-items v-model="tab">
					<v-tab-item>
						<CompanyTaxesConfig />
					</v-tab-item>
					<v-tab-item v-if="company?.config?.supervision_allowed">
						<div>
							<CompanyMaterialsConfig :company="company"/>
						</div>
					</v-tab-item>
					<v-tab-item v-if="company?.config?.supervision_allowed">
						<div>
							<CompanySupervisionPercentConfig :company="company"/>
						</div>
					</v-tab-item>
				</v-tabs-items>
			</div>
		</v-menu>
	</div>
</template>

<script>
import CompanyTaxesConfig from '@/components/Views/Companies/CompanyTaxesConfig'
import CompanyMaterialsConfig from '@/components/Views/Companies/CompanyMaterialsConfig'
import CompanySupervisionPercentConfig from '@/components/Views/Companies/CompanySupervisionPercentConfig'

export default {
	name: 'CompanyListConfig',
	components: {
		CompanyTaxesConfig,
		CompanyMaterialsConfig,
		CompanySupervisionPercentConfig
	},
	props: {
		isMyCompany: {
			type: Boolean,
			required: true
		},
		company: {
			type: Object,
			required: true
		}
	},
  data: () => ({
		menuOpen: false,
		tab: 0,
  }),
}
</script>

<style>

</style>